// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { translateFromPresentation } from "@sequentech/ui-core";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
export var MISSING_ALIAS = "-";
var isPlainObject = function (value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
};
export function useAliasRenderer() {
    var i18n = useTranslation().i18n;
    var aliasRenderer = useCallback(function (item, defaultLang) {
        var t = function (x) {
            return translateFromPresentation(x, "alias", i18n.language) ||
                translateFromPresentation(x, "name", i18n.language) ||
                (defaultLang
                    ? translateFromPresentation(x, "alias", defaultLang) ||
                        translateFromPresentation(x, "name", defaultLang)
                    : undefined) ||
                translateFromPresentation(x, "alias", "en") ||
                translateFromPresentation(x, "name", "en") ||
                MISSING_ALIAS;
        };
        if (item == null)
            return MISSING_ALIAS;
        if (isPlainObject(item)) {
            return t(item);
        }
        var s = String(item).trim();
        if (!s)
            return MISSING_ALIAS;
        if (s.startsWith("{")) {
            try {
                return t(JSON.parse(s));
            }
            catch (_a) {
                return MISSING_ALIAS;
            }
        }
        return MISSING_ALIAS;
    }, [i18n.language]);
    return aliasRenderer;
}
